import axios from './http'
import qs from 'qs'

function get () {
  return axios.post('public/liveNotice.json')
}
function postBodyData (params) {
  return axios.post('appEducation/query', params)
}
function postFormData (params) {
  return axios.post('liveTelecast/liveTelecastDetail', qs.stringify(params))
}

// 登录
const login = params => axios.post('bacc/report/login', params)
// 获取验证码
const getCode = params => axios.get('bacc/report/phoneVeriCode', { params })
// 获取风险评估数据
const getFxCode = params => axios.get('bacc/report/getRiskAssessment', { params })
// 获取城市列表
const getCity = () => axios.get('user/hisArea/list')
// 获取预约 or 筛查列表
const getList = params => axios.get('bacc/report/getByPhone', { params })
// 获取预约详情
const getSubById = params => axios.get('bacc/userCaseHistory/getSubById', { params })
// 获取筛查详情
const getByPk = params => axios.get('bacc/userCaseHistory/getResByPkWithPic', { params })
// 上传图片
const uploadImg = params => axios.post('bacc/hisPicture/pictureUpdate', params)
// 获取医生列表
const getDoctorList = params => axios.get('bacc/report/getRecommendDoctor', { params })
// 获取报告详情
const getReportDetail = params => axios.get('bacc/userCaseHistory/getResByPkWithPic', {
  params: {
    id: params.id,
    type: 0
  }
})
// 获取知情同意书模板类型
const getAgreementType = ({ id }) => axios.get(`bacc/hisAgreement/getByCaseId/${id}`)

// 获取科普列表
const getBookList = params => axios.post('bacc/report/bookList', params)
// 获取科普详情
const getBookDetails = params => axios.get('bacc/report/getBookById', { params })
// 获取科普点赞
const bookDz = params => axios.get('bacc/report/bookDz', { params })

// 获取消息列表
const getMessageList = params => axios.post('wechat/getMessageList', params)
// 获取消息详情
const getMessageById = params => axios.get('wechat/getMessageById', { params })

// 获取排班日期
const getSubTimeListByIns = params => axios.get('bacc/hisCheackSubscribe/getSubTimeListByIns', { params })
// 获取当日预约排班
const getSubscribeListByIns = params => axios.get(`bacc/hisCheackSubscribe/getSubscribeListByIns/${params.insId}/date/${params.date}`)

// 预约登记第一步保存
const subscribe = params => axios.post('bacc/userCaseHistory/subscribe', params)
// 预约登记更新
const update = params => axios.put('bacc/userCaseHistory/update', params)
// 获取机构详情
const getInstitutionById = params => axios.get('bacc/sysmanager/getInstitutionById', { params })
// 通过身份证base64信息获取身份证信息
const getIdCardInfoFromBase64 = params => axios.post('bacc/idCard/getIdCardInfoForSub', params)
// 身份证居住地址解析
const addressAnalysis = params => axios.get('bacc/idCard/addressAnalysis', { params })
// 身份证户籍地址解析
const idcardAddressAnalysis = params => axios.get('bacc/idCard/idcardAddressAnalysis', { params })
// 身份证号码校验
const validateIDCard = params => axios.post('/bacc/idCard/idCardInfoVerify', params)
// 地址解析
const getAreaByPa = params => axios.get('user/hisArea/getAreaByPa', { params })
// 获取筛查时间表
const getArrangeBySubId = params => axios.get(`bacc/hisCheackSubscribe/getArrangeBySubId/${params.id}`)
// 取消预约
const usercaseDelete = params => axios.post('bacc/userCaseHistory/usercaseDelete', params)
// 图片切换标签
const pictureEdit = params => axios.get('userCaseHistory/pictureEdit', { params })

// 图片切换标签
const signture = params => axios.get('bacc/wx/jsSdkWithoutCode', { params })

// 获取模板详情
const getTemplateInfo = params => axios.get(`bacc/template/${params.id}`)
// 上传签名的base64图片
const uploadBase64 = params => axios.post('/bacc/hisAgreement/uploadImage64', params)

// 获取模板详情
const reportSel = params => axios.get('bacc/userCaseHistory/reportSel', params)

// 妇女库查重
const sendToCheck = params => axios.post('bacc/userCaseHistory/sendToCheck1', params)

export default {
  sendToCheck,
  login,
  getCode,
  getFxCode,
  getCity,
  getList,
  getSubById,
  getByPk,
  uploadImg,
  getDoctorList,
  getBookList,
  getBookDetails,
  bookDz,
  getMessageList,
  getMessageById,
  getReportDetail,
  getAgreementType,
  validateIDCard,

  getSubTimeListByIns,
  getSubscribeListByIns,
  subscribe,
  update,
  getInstitutionById,
  getIdCardInfoFromBase64,
  addressAnalysis,
  idcardAddressAnalysis,
  getAreaByPa,
  getArrangeBySubId,
  usercaseDelete,
  pictureEdit,

  get,
  postBodyData,
  postFormData,
  signture,
  getTemplateInfo,
  uploadBase64,

  reportSel
}
